// extracted by mini-css-extract-plugin
export default {"root":"GriphSizes_root__c4xrM","root__item":"GriphSizes_root__item__NdklJ","root_active":"GriphSizes_root_active__wC7Bv"};